<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/mobile-device-security",
		    "name": "Mobile Device Security"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
      <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <ul class="breadcrumbsul">
                  <li><a href="#">Home</a></li>
                  <li>></li>
                  <li>Mobile Device Security</li>
              </ul>
          </div>
      </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}} </h1>
          <h2 id="bnr-subheading">{{subheading}}</h2>
          
          <div class="d-flex social-btns">
            <a target="_blank" class="app-btn blu flex vert mds-icon ml-1"
              href="https://play.google.com/store/apps/details?id=ai.protectt.mprotectt_v2">
              <img src="assets/images/android/play_store.webp" alt="PlayStore Image" class="img-fluid">
            </a>
          </div>
         
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                  <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
                <h4 id="bnr-subheading">{{subheading}}</h4>
                
                <div class="flex social-btns">
                  <a target="_blank" class="app-btn blu flex vert mds-icon ml-1"
                    href="https://play.google.com/store/apps/details?id=ai.protectt.mprotectt_v2">
                    <img src="assets/images/android/play_store.webp" alt="PlayStore Image" class="img-fluid">
                  </a>
                </div>
               
            </div>
        </div>
    </div>
</div>
<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit">
  <div class="container">
    <div  class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <!-- <span style="color: #da2b27;">Innovativeness</span> -->
            <div>
              <h2>Life is shrunk to Rectangular Screens of Mobile Phones</h2>
            </div>
            <p>From morning alarms to read e-mails on our mobile device we spent our day with mobile phones. We are
              bound to rectangular screen of our mobile device for many tasks viz, shopping, paying bills or talking to
              our friends.</p>
            <p>But, this ease of convenience comes with a risk. We provide our valuable information, store private
              information on device, and even share financial details on mobile device. This information needs to be
              cyber secured. Otherwise, any misuse of information could lead to your reputation or financial loss.</p>
            <!-- <p>“Learning curve must go on”</p> -->

          </div>
        </div>
      </div>
      <div class="col-lg-6 order-md-first">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/mobile-device-security/image-3.webp" class="og_image_url" alt="Secure your Data and Digital Payments with Best Antivirus Protecion for Android">
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div  class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <!-- <span style="color: #da2b27;">Our clients</span> -->
            <div>
              <h2>Secure Privacy – Secure Mobile Devices</h2>
            </div>
            <p>Securing a digital is must. Considering the increase in cyber attacks and frauds it’s a high time we
              start securing our mobile devices.</p>
            <p>MProtectt makes it easy to secure mobile device from any privacy breach. It provides you 360
              -degree security to your mobile device – Application, Device or Network based attacks. It secures all the
              corners and provide end-to-end protection.</p>
            <p>MProtectt safeguards your mobile device and privacy & enhance the surfing experience with web
              security, battery & memory optimization.</p>
              
            <div class="flex social-btns">
              <a target="_blank" class="app-btn blu flex vert mds-icon ml-1"
              href="https://play.google.com/store/apps/details?id=ai.protectt.mprotectt_v2">
              <img src="assets/images/android/play_store.webp" alt="PlayStore Image" class="img-fluid">
            </a>
            </div>
           
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/mobile-device-security/image-4.webp" alt="Secure Data of your Mobile ">
          </div>
        </div>
      </div>

    </div>
    <div class="content text-center pb-3">
      <a class="btn-rectangle btn-transparent btn" routerLink="/mprotectt">Learn More</a>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Testimonial Style -->
<div class="section-testimonial-carousel section-pb">
  <div class="container">
    <div  class="row">
      <div class="col-lg-12">
        <div class="section-title text-center">
          <h2>Protectt.ai Mobile Device Security Offerings</h2>
          <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore</p> -->
        </div>
      </div>
    </div>
    <ngx-slick-carousel  class="carousel col-md-12 rasp-carousel newcard" #slickModal="slick-carousel" [config]="slideConfig"
      (init)="slickInit()" (breakpoint)="breakpoint()" (afterChange)="afterChange()" (beforeChange)="beforeChange()">
      <div ngxSlickItem *ngFor="let slide of slides" class="slide">
        <!-- <img src="{{ slide.img }}" alt="slide" width="90%" height="180px"> -->
        <div class="card height-180px my-0 mx-2">
          <div class="card-body d-flex align-items-center text-uppercase justify-content-center text-center">
            <h4 class="card-title">{{slide.text}}</h4>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>
</div>
<!-- <div class="section-testimonial-carousel bg-gray section-pt section-pb">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="section-title text-center">
                    <h2>Our Prestigious App Protectt Partners</h2>
                </div>
            </div>
        </div>
  <ngx-slick-carousel class="carousel"
  #slickModal="slick-carousel"
  [config]="slide1Config"
  (init)="slick1Init()"
  (breakpoint)="breakpoint1()"
  (afterChange)="afterChange1()"
  (beforeChange)="beforeChange1()">
<div ngxSlickItem *ngFor="let slide of slides1" class="slide">
    <img src="{{ slide.img }}" alt="slide" width="100%">
</div>
</ngx-slick-carousel>
</div>
</div> -->

<!-- End Testimonial Style -->

<!-- Start  Buttons -->
<!-- <div class="bg-gray section-service section-pt">
    <div class="container">
        <div class="header-btn text-center">
            <a href="#" class="btn contact-btn mt-30 btn-circle">Request a Demo</a>
            <a href="#" class="btn contact-btn mt-30 btn-circle">Check Our Product for Free</a>
            <a href="#" class="btn contact-btn mt-30 btn-circle">Contact Sales</a>
        </div>
    </div>
  </div> -->

<!-- End Buttons -->